import * as React from 'react'
import { AppContainer } from "./containers/TicketingContainer";
import { Route, Switch } from 'react-router-dom';
import { FacebookPage } from "./routes/facebook"
import { DesktopPage, EmbedPage } from "./routes/desktop";
import { ClientType } from "Apps/shared/ClientHost/type";

export default () => {
  if (process.env.NODE_ENV === 'production') {
    window.oncontextmenu = function () {
      return false;
    }
    document.onkeydown = function (e: any) {
      // @ts-ignore
      if (window.event.keyCode == 123 ||  e.button==2)
        return false;
    }
  }

  return (
    <AppContainer app={ClientType.normal}>
      <Switch>
        <Route path="/facebook/:page_id" component={FacebookPage}/>
        <Route path="/embed/:id" component={EmbedPage}/>
        <Route path="/e/:id" component={EmbedPage}/>
        <Route path="/:id" component={DesktopPage}/>
      </Switch>
    </AppContainer>
  )
};



// WEBPACK FOOTER //
// ./src/Apps/ticketing/Desktop.tsx